import { imagesPath } from '@shared/css.const';
import { Image } from '@mantine/core';
import { Text, Flex } from '@huspy/briks-web';

type EmptyTemplateProps = {
  title: string;
  description: string;
  cta: React.ReactNode
};

export const EmptyTemplateComponent = ({ title, description, cta }: EmptyTemplateProps) => (
  <Flex direction='column' alignItems='center' data-testid='empty-template'>
    <Image src={ `${imagesPath}/empty-template/empty-folder.svg` } w={ 320 } h={ 320 } />
    <Text size='3xl' data-testid='empty-title'>{title}</Text>
    <Text color='text-tertiary' letterSpacing='-0.8' fontSize='md' size='3xl' data-testid='empty-description'>
      {description}
    </Text>
    {cta && <div data-testid='empty-cta'>{cta}</div>}
  </Flex>
);
